exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-box .my-input[data-v-02233d83] {\n  max-width: 215px;\n}\n.my-box .el-row[data-v-02233d83] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-02233d83]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-02233d83] {\n  border-radius: 4px;\n}\n.my-box .grid-content[data-v-02233d83] {\n  border-radius: 4px;\n  height: 36px;\n  white-space: nowrap;\n}\n.my-box .grid-content .el-input__inner[data-v-02233d83] {\n    max-width: 190px;\n}\n.my-box .grid-content span[data-v-02233d83] {\n    font-size: 14px;\n}\n", ""]);

// exports
